import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  label: {
    color: colors.white,
    fontSize: 36,
    fontWeight: 600,
    margin: "60px 0 30px 0",
    position: "relative",
    [Commons.smallQuery]: {
      fontSize: 30,
      textAlign: "center",
    },
  },
  infoContainer: {
    ...Commons.flexRow,
    gap: 30,
    marginBottom: 120,
    justifyContent: "center",
    alignItems: "start",
    [Commons.midQuery]: {
      marginBottom: 90,
      flexDirection: "column",
    },
  },
  columnInfo: {
    flex: 1,
    [Commons.smallQuery]: {
      flex: "unset",
      width: "100%",
      maxWidth: "unset",
    },
  },
  cardRole: {
    ...Commons.flexColumn,
    alignItems: "center",
    justifyContent: "end",
    borderRadius: 25,
    overflow: "hidden",
    padding: 36,
    boxShadow: colors.shadowPurlpeInset,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    // minHeight: 472,
    minHeight: 372,
    [Commons.smallQuery]: {
      padding: 12,
      flexDirection: "column",
      minHeight: "unset",
    },
  },
  titleRole: {
    color: colors.white,
    textAlign: "left",
    fontWeight: 600,
    fontSize: 30,
    margin: "12px 0",
    [Commons.smallQuery]: {
      fontSize: 30,
      textAlign: "center",
    },
  },
  rowInfo: {
    ...Commons.flexColumn,
    alignItems: "flex-start",
    [Commons.smallQuery]: {
      alignItems: "center",
    },
  },
  containerIcon: {
    ...Commons.flexCenter,
    height: 240,
    width: 240,
    [Commons.smallQuery]: {
      height: "unset",
      width: "unset",
      marginTop: 30,
    },
  },
  imageIcon: {
    height: 180,
    width: 240,
    objectFit: "cover",
  },
  descriptionRole: {
    color: colors.white,
    fontSize: 18,
    whiteSpace: "break-spaces",
    textAlign: "left",
    margin: 0,
    [Commons.smallQuery]: {
      margin: "0 0 24px 0 ",
      textAlign: "center",
      fontSize: 16,
      padding: "0 18px",
    },
  },
  buttonRole: {
    ...Commons.defaultButton,
    backgroundColor: colors.orange,
    color: `${colors.white} !important`,
    fontWeight: "bold !important",
    fontSize: "18px !important",
    padding: "12px 36px",
    borderRadius: 24,
    margin: "24px 0 0 0 !important",
    transition: "all 0.2s",
    width: "100%",
    textDecoration: "unset !important",
    boxSizing: "border-box",
    textAlign: "center",
    "&:hover": {
      boxShadow: colors.shadowWhite,
    },
    [Commons.smallQuery]: {
      margin: "24px 0 30px 0",
      maxWidth: "90%",
    },
  },
  "@keyframes neonBgLoop": {
    "0%": {
      boxShadow: `inset 0 0 50px 3px ${colors.secondary}50`,
    },
    "50%": {
      boxShadow: `inset 0 0 50px 3px ${colors.secondary}`,
    },
    "100%": {
      boxShadow: `inset 0 0 50px 3px ${colors.secondary}50`,
    },
  },
});

export default styles;
